import React from 'react';

const PageWrapper = ({ children }) => (
  <div className='page-wrapper'>
    {children}
  </div>
)

export default PageWrapper;
